import { runtimeConfig } from "@src/runtime-config";
import { IReactChildrenOnly } from "@custom-types/types";
import { HBCookieManagerProvider } from "@faro-lotv/foreign-observers";

/**
 * Loads both the Cookie Manager and Google Tag Manager
 */
export function CookieManagerLoader({
  children,
}: IReactChildrenOnly): JSX.Element {
  return (
    // If the URL is undefined or empty the cookie manager will not be loaded
    <HBCookieManagerProvider
      cookieManagerUrl={runtimeConfig.urls.cookieManagerUrl}
      options={{
        /* eslint-disable @typescript-eslint/naming-convention -- Names from package */
        preferencesButton: false,
        preferencesButtonPosition: "bottom right",
        requireBabelPolyfill: true,
        requireJquery: true,
        requireBootstrap: true,
        triggerGoogleTagManager: true,
        delay: 300,
        /* eslint-enable @typescript-eslint/naming-convention */
      }}
    >
      {children}
    </HBCookieManagerProvider>
  );
}
